import { render, staticRenderFns } from "./Remarkable.vue?vue&type=template&id=7dff82ee&scoped=true"
import script from "./Remarkable.vue?vue&type=script&lang=js"
export * from "./Remarkable.vue?vue&type=script&lang=js"
import style0 from "./Remarkable.vue?vue&type=style&index=0&id=7dff82ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dff82ee",
  null
  
)

export default component.exports